"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TertiaryButtonTheme = exports.SecondaryButtonTheme = exports.PrimaryButtonTheme = exports.DestructiveButtonTheme = exports.DangerTertiaryButtonTheme = exports.DangerButtonTheme = void 0;
var _colors = require("../../colors");
var lightShadowOpacity = 0.13;
var darkShadowOpacity = 0.3;
var PrimaryButtonTheme = exports.PrimaryButtonTheme = {
  loadingSpinnerFlavor: 'pale',
  "default": {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.IRIS_600,
    backgroundColor: _colors.FullPalette.IRIS_600,
    iconColor: _colors.FullPalette.WHITE
  },
  hover: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.IRIS_700,
    backgroundColor: _colors.FullPalette.IRIS_700,
    dropShadowOpacity: darkShadowOpacity,
    iconColor: _colors.FullPalette.WHITE
  },
  active: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.IRIS_700,
    backgroundColor: _colors.FullPalette.IRIS_700,
    iconColor: _colors.FullPalette.WHITE
  }
};
var SecondaryButtonTheme = exports.SecondaryButtonTheme = {
  loadingSpinnerFlavor: 'green',
  "default": {
    color: _colors.FullPalette.GREEN_700,
    borderColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.WHITE,
    iconColor: _colors.FullPalette.GREEN_700
  },
  hover: {
    color: _colors.FullPalette.EVERGREEN_700,
    borderColor: _colors.FullPalette.EVERGREEN_700,
    backgroundColor: _colors.FullPalette.WHITE,
    dropShadowOpacity: lightShadowOpacity,
    iconColor: _colors.FullPalette.EVERGREEN_700
  },
  active: {
    color: _colors.FullPalette.EVERGREEN_700,
    borderColor: _colors.FullPalette.EVERGREEN_700,
    backgroundColor: _colors.FullPalette.GREY_E25,
    iconColor: _colors.FullPalette.EVERGREEN_700
  }
};
var DangerButtonTheme = exports.DangerButtonTheme = {
  loadingSpinnerFlavor: 'poppy',
  "default": {
    color: _colors.FullPalette.POPPY_600,
    borderColor: _colors.FullPalette.POPPY_600,
    backgroundColor: _colors.FullPalette.WHITE,
    iconColor: _colors.FullPalette.POPPY_600
  },
  hover: {
    color: _colors.FullPalette.POPPY_700,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.WHITE,
    dropShadowOpacity: lightShadowOpacity,
    iconColor: _colors.FullPalette.POPPY_700
  },
  active: {
    color: _colors.FullPalette.POPPY_700,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.GREY_E25,
    iconColor: _colors.FullPalette.POPPY_700
  }
};
var DestructiveButtonTheme = exports.DestructiveButtonTheme = {
  loadingSpinnerFlavor: 'pale',
  "default": {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.POPPY_600,
    backgroundColor: _colors.FullPalette.POPPY_600,
    iconColor: _colors.FullPalette.WHITE
  },
  hover: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.POPPY_700,
    dropShadowOpacity: darkShadowOpacity,
    iconColor: _colors.FullPalette.WHITE
  },
  active: {
    color: _colors.FullPalette.WHITE,
    borderColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.POPPY_700,
    iconColor: _colors.FullPalette.WHITE
  }
};
var TertiaryButtonTheme = exports.TertiaryButtonTheme = {
  "default": {
    color: _colors.FullPalette.GREEN_700
  },
  hover: {
    color: _colors.FullPalette.EVERGREEN_700
  }
};
var DangerTertiaryButtonTheme = exports.DangerTertiaryButtonTheme = {
  "default": {
    color: _colors.FullPalette.POPPY_600
  },
  hover: {
    color: _colors.FullPalette.POPPY_500
  }
};